import styled from '@emotion/styled'
import { FC } from 'react'
import { LinkExternal } from '@emotion-icons/octicons/LinkExternal'
import { CircleIcon } from 'src/components/icons/circle-icon'
import { MapTooltip } from 'src/v2/components/map-tooltip'
import { MapSquareIcon } from 'src/components/icons/map-square'
import { Colors } from 'src/components/theme'
import { Typography } from '@mui/material'
import { FlexColumn, FlexRow } from 'src/components/flex-containers'
import { ParcelTypeChip } from 'src/v2/components/parcel-type-chip'
import { formatVal } from 'src/utils/number-format'

const OpenInMEWrapper = styled(FlexRow)`
  cursor: pointer;
  width: fit-content;
`

const HeaderContainer = styled(FlexColumn)`
  min-width: 260px;
`

const Column = styled(FlexColumn)`
  flex: 1;
`

type HeaderProps = {
  parcel: any
}
const Header: FC<HeaderProps> = ({ parcel }) => {
  return (
    <HeaderContainer gap={10}>
      <FlexRow gap={8}>
        <CircleIcon size={32} color={Colors.primaryGreen700}>
          <MapSquareIcon size={14} />
        </CircleIcon>
        <FlexColumn gap={2}>
          <Typography variant="title1" fontSize={16} fontWeight="700" color={Colors.neutral950}>
            {parcel.name}
          </Typography>
          <Typography variant="text1m" fontSize={12} color={Colors.neutral500}>
            {`APN # ${parcel.apn}`}
          </Typography>
        </FlexColumn>
      </FlexRow>
      <OpenInMEWrapper gap={4}>
        <LinkExternal size={16} color={Colors.blueDark} />
        <Typography variant="textmdm" color={Colors.blueDark}>
          Open in Map Explorer
        </Typography>
      </OpenInMEWrapper>
    </HeaderContainer>
  )
}

type AcquisitionsOverviewMapTooltipProps = {
  parcel: any
}
export const AcquisitionsOverviewMapTooltip: FC<AcquisitionsOverviewMapTooltipProps> = ({ parcel }) => {
  return (
    <MapTooltip heading={<Header parcel={parcel} />}>
      <FlexColumn gap={16}>
        <FlexRow>
          <Column gap={4}>
            <Typography variant="title2m" color={Colors.neutral400}>
              Date
            </Typography>
            <Typography variant="title1" fontSize={16} color={Colors.neutral950}>
              {parcel.date}
            </Typography>
          </Column>
          <Column gap={4}>
            <Typography variant="title2m" color={Colors.neutral400}>
              Activity
            </Typography>
            <Typography variant="title1" fontSize={16} color={Colors.neutral950}>
              {parcel.activity}
            </Typography>
          </Column>
        </FlexRow>
        <FlexRow>
          <Column gap={4}>
            <Typography variant="title2m" color={Colors.neutral400}>
              Parcel Type
            </Typography>
            <ParcelTypeChip type={parcel.type} maxWidth={118} />
          </Column>
          <Column gap={4}>
            <Typography variant="title2m" color={Colors.neutral400}>
              Recent Sale Price
            </Typography>
            <Typography variant="title1" fontSize={16} color={Colors.neutral950}>
              {formatVal(parcel.recentSalePrice, 'currency-long')}
            </Typography>
          </Column>
        </FlexRow>
      </FlexColumn>
    </MapTooltip>
  )
}
